import { fetchRevenueTrendDetails } from "egov-ui-kit/redux/app/actions";
import React, { useEffect } from "react";
import { Bar } from "react-chartjs-2";
// import { getChartData } from "../Inbox/components/mockData";

const styles = {
  chartHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "16px",
  },
  chartTitle: {
    margin: 0,
    fontSize: "15px",
    fontWeight: 700,
    color: "#111827",
  },
  chartSubtitle: {
    margin: "4px 9px 2px",
    fontSize: "12px",
    color: "#6b7280",
  },
  chartHeaderFlex: {
    display: "flex",
    alignItems: "center",
  },
};

// const BarCharts = ({ appliedFilters }) => {
const BarCharts = (props) => {
  // const chartData = getChartData(appliedFilters);

  const { revenueTrend } = props;
  const trend = revenueTrend && revenueTrend.revenueTrend;
  console.log(revenueTrend);

  const barData = {
    labels: trend && trend.labels,
    datasets: [
      {
        label: "Gross Receipts",
        data: trend && trend.receipts,
        backgroundColor: "#16A085",
        borderRadius: 5,
        barThickness: 18,
      },
      {
        label: "Total Expenditure",
        data: trend && trend.expenditure,
        backgroundColor: "#FF5722",
        borderRadius: 5,
        barThickness: 18,
      },
    ],
  };

  const barOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        labels: { usePointStyle: true, font: { size: 12 } },
      },
      tooltip: {
        callbacks: {
          label: (ctx) => ` ₹${ctx.parsed.y.toLocaleString("en-IN")} Cr`,
        },
      },
    },
    scales: {
      x: { grid: { display: false } },
      y: {
        beginAtZero: true,
        ticks: {
          callback: (v) => `₹${v}`,
        },
      },
    },
  };

  // const subtitle =
  //   appliedFilters.ulbName !== "All ULBs" ? appliedFilters.ulbName : appliedFilters.ulbType !== "All ULBs" ? appliedFilters.ulbType : "All ULBs";

  return (
    <div>
      <div style={styles.chartHeader}>
        <div style={styles.chartHeaderFlex}>
          <div className="zone-wise-header">
            <div className="header wrapper-header">
              <div className="icon-wrapper">
                <i className="material-icons">description</i>
              </div>
              <div>
                <h2>Revenue Overview</h2>
              </div>
            </div>
            <div className="receipt-header receipt-header-bar-chart">
              <span>Financial Year {revenueTrend.financialYear}</span>
              {/* <span>Financial Year {appliedFilters.financialYear}</span> */}
              <span>|</span>
              <span>ULB: {revenueTrend.ulbName}</span>
            </div>
          </div>
        </div>
      </div>
      <div style={{ height: "320px", width: "500px" }}>
        <Bar data={barData} options={barOptions} />
      </div>
    </div>
  );
};

export default BarCharts;



// WEBPACK FOOTER //
// src/modules/employee/Home/BarCharts.js